export default "__VITE_ASSET__166d4846__"